window.APR_PUSHER_SEARCH_CHANNEL = 'search-results.%s';
window.APR_PUSHER_SEARCH_RESULTS_UPDATED_EVENT = '.SearchResultsUpdatedEvent';
window.APR_PUSHER_SEARCH_META_UPDATED_EVENT = '.SearchMetaUpdatedEvent';
window.APR_PUSHER_SEARCH_STATUS_UPDATED_EVENT = '.SearchStatusUpdatedEvent';
